import { Card, Col } from "reactstrap";
import { LabelText } from "../Utils/Input";
import { formatNumberForStatistics } from "./constants/HandleChangeFunctions";

export const InvoiceAnalyticsCard = ({
  heading,
  currencyCode,
  totalAmount,
  particularTotalCount,
  icon,
}) => {
  return (
    <Col xxl={3} md={6} className="px-2">
      <div className="border rounded-1 pb-4">
        <div className="d-flex justify-content-between align-items-center ">
          <LabelText
            classLabelName={"fw-bold rv-text-color fs-5 ps-3 pt-3"}
            displayText={heading}
          />
        </div>
        <div>
          <LabelText
            classLabelName={"fw-bold rv-text-color fs-1 ps-3 pt-2"}
            displayText={`${formatNumberForStatistics(totalAmount || 0)}`}
            // displayText={`${currencyCode || ""} ${formatNumberForStatistics(
            //   totalAmount || 0
            // )}`}
          />
        </div>
        {/* <div className="d-flex justify-content-between  align-items-center">
                    <div className="ps-3 pt-4">
                        <LabelText classLabelName={"invoice-count text-white px-3 rounded me-2 fw-bold"} displayText={particularTotalCount || 0} />
                        <LabelText classLabelName={"invoice-text-color fw-bold"} displayText={"Invoices Sent"} />
                    </div>
                    <i className={`${icon} invoice-percent-and-icon-color invoice-icon-size pe-4`}></i>
                </div> */}
      </div>
    </Col>
  );
};
